import { render } from "./TaskAction.vue?vue&type=template&id=294099e5"
import script from "./TaskAction.vue?vue&type=script&lang=js"
export * from "./TaskAction.vue?vue&type=script&lang=js"

import "./TaskAction.vue?vue&type=style&index=0&id=294099e5&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__